import React, {Component, useEffect, useState} from "react";
import {Card, ListGroup} from "react-bootstrap";
import {getAuth, onAuthStateChanged} from "@firebase/auth";
import {Location, NewsItem, Session, User} from "../types/Types";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import NewsItemRow from "./NewsItemRow";
import HubNav from "./HubNav";
import {NOTIFICATION_LIMIT, logDataLoaded} from "../util/Util";
import PageTracking from "../auth/PageTracking";
import {useNavigate} from "react-router";

interface Props {
    usersMap: Map<string, User>;
    sessionsMap: Map<string, Session>;
    currentUser: User | undefined;
}

function Visits(props: Props) {
    const navigate = useNavigate();

    const [newsItems, setNewsItems] = useState<Array<NewsItem> | undefined>(undefined);

    useEffect(() => {
        (async () => {
            const auth = getAuth();
            onAuthStateChanged(auth, async (currentUser) => {
                if (!currentUser) {
                    navigate('/');
                    return;
                }
            });
        })();
    }, []);

    useEffect(() => {
        (async () => {
            await loadAllData();
        })();
    }, []);

    const loadAllData = async() => {

        // Load visit news items
        let newsItems: Array<NewsItem> = [];
        const newsOnceCollection = query(collection(db, 'news'),
            where('type', '==', 'VISIT'),
            orderBy('lastModified', 'desc'),
            limit(NOTIFICATION_LIMIT));
        const newsOnceCollectionSnapshot = await getDocs(newsOnceCollection);
        newsOnceCollectionSnapshot.forEach((doc) => {
            let tempNewsItem = doc.data() as NewsItem;
            newsItems.push(tempNewsItem);
        });
        logDataLoaded('visits', newsItems.length);
        setNewsItems(newsItems);

    };

    return (
        <>
            <PageTracking />
            <HubNav currentUser={props.currentUser} />
            <Card className={"mb-3"}>
                <ListGroup variant="flush">
                    {!newsItems && <div className={'loading'}>
                        Loading...
                    </div>}
                    {(newsItems && newsItems.length == 0) &&<div className={'loading'}>
                        No visits yet
                    </div>}
                    {newsItems && newsItems.map((newsItem: NewsItem, index: number) => (
                        <NewsItemRow user={props.usersMap.get(newsItem.userId)} newsItem={newsItem} session={props.sessionsMap.get(newsItem.userId)}/>
                    ))}
                </ListGroup>
            </Card>
        </>
    )
}

export default Visits;